export default __webpack_public_path__ + "static/media/pandora_card.9afb4d91.png";